/**
 * 앱 환경 판정 (단일 진실원)
 *
 * 개발/운영 구분 기준:
 *   1) .env* 의 REACT_APP_ENV 값 (development | production) 우선.
 *   2) 없으면 CRA가 자동 설정하는 NODE_ENV로 fallback
 *      (npm start → development, npm run build → production).
 *
 * IS_DEV는 헤더 DEV 배지 노출 등 개발 전용 UI 게이트로 사용.
 */

export type AppEnv = 'development' | 'production';

export const APP_ENV: AppEnv =
  process.env.REACT_APP_ENV === 'development' || process.env.REACT_APP_ENV === 'production'
    ? process.env.REACT_APP_ENV
    : process.env.NODE_ENV === 'production'
      ? 'production'
      : 'development';

/** 개발 환경 여부. 운영 빌드에서는 false. */
export const IS_DEV = APP_ENV === 'development';

/** 현재 백엔드 API base URL (표시용). client.ts의 API_BASE와 동일 규칙. */
export const API_BASE = process.env.REACT_APP_API_BASE ?? '/api';
